import React, { useState } from 'react'
import { Popover, Typography, Button, CircularProgress, Autocomplete, TextField, Box } from '@mui/material'
import BadgeFilter from './BadgeFilter'
import Helper from '../../helpers/Helper'
import { ISystemConfig } from '../../definitions/MiscSchema'

interface Props {
    name: string
    value: string
    isLoading: boolean
    options: ISystemConfig[]
    onApply: (newValue: string) => void
}

const SelectBadgeFilter = ({ name, isLoading, value, options, onApply }: Props) => {
    const isActive = Helper.hasVal(value)

    const [selection, setSelection] = useState(isActive ? value : null)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const isOpen = Boolean(anchorEl)
    const selectedOption = options.find(x => x.uuid === selection)

    return (
        <div>
            <div
                style={{ width: 'fit-content' }}
                onClick={event => {
                    setSelection(isActive ? value : null)
                    setAnchorEl(event.currentTarget)
                }}>
                <BadgeFilter
                    isActive={isActive}
                    name={name}
                    onReset={() => {
                        setSelection(null)
                    }}
                />
            </div>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={() => {
                    setSelection(value)
                    setAnchorEl(null)
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: 320,
                            maxWidth: 400
                        }
                    }
                }}>
                {isLoading
                    ? (
                            <Box height={100} width='100%' display='flex' justifyContent='center' alignItems='center'>
                                <CircularProgress />
                            </Box>
                        )
                    : (
                            <Box p={1} width='100%'>
                                <Typography variant='overline'>
                                    Filter by
                                    {name}
                                </Typography>
                                <Autocomplete
                                    size='small'
                                    id='tags-standard'
                                    options={options}
                                    value={selectedOption}
                                    getOptionLabel={option => {
                                        if (Helper.hasVal(option)) {
                                            return option.name ?? option.uuid
                                        }
                                    }}
                                    onChange={(e, value) => {
                                        if (Helper.hasVal(value))
                                            setSelection(value.uuid)
                                        else
                                            setSelection(null)
                                    }}
                                    renderOption={(props, option) => (
                                        <Box component='li' {...props} key={option.uuid} sx={{ padding: 1 }}>
                                            <Typography>{option.name}</Typography>
                                        </Box>
                                    )}
                                    renderInput={params => {
                                        return (
                                            <TextField
                                                {...params}
                                                variant='standard'
                                                label='Single value'
                                            />
                                        )
                                    }}
                                />
                                <Button
                                    sx={{ marginTop: 2 }}
                                    fullWidth
                                    size='small'
                                    variant='outlined'
                                    onClick={() => {
                                        onApply(selection)
                                        setAnchorEl(null)
                                    }}>
                                    Apply
                                </Button>
                            </Box>
                        )}
            </Popover>
        </div>
    )
}

export default SelectBadgeFilter
